import * as echarts from "echarts";

/* Remerge Design System chart theme (admin context).
   Palette: monochrome base + sparingly-used DS accents. */

const DS = {
  black: "#1D1D1F",
  textSecondary: "#737373",
  textDisabled: "#999999",
  border: "#E6E6E6",
  bg: "#F6F4F2",
  violet: "#D0C8FB",
  yellow: "#F0FF71",
  olive: "#BFBDA9",
  green: "#58655B",
  lightBlue: "#E1E4EE",
  successDark: "#26B941",
  warningDark: "#E17655",
  errorDark: "#FF0000",
} as const;

const FONT_UI = "'GT America Regular', Helvetica, Arial, sans-serif";

const wprTheme: Record<string, unknown> = {
  color: [DS.black, DS.violet, DS.olive, DS.green, DS.lightBlue, DS.textSecondary, DS.yellow],
  backgroundColor: "transparent",
  textStyle: {
    fontFamily: FONT_UI,
    color: DS.black,
  },

  title: {
    textStyle: {
      fontFamily: "'GT America Condensed', Helvetica, Arial, sans-serif",
      color: DS.black,
      fontWeight: 400,
      fontSize: 14,
    },
  },

  valueAxis: {
    axisLine: { lineStyle: { color: DS.border } },
    axisTick: { lineStyle: { color: DS.border } },
    axisLabel: {
      color: DS.textDisabled,
      fontFamily: FONT_UI,
      fontSize: 10,
    },
    splitLine: {
      lineStyle: {
        type: "solid",
        width: 1,
        color: DS.border,
      },
    },
  },
  categoryAxis: {
    axisLine: { lineStyle: { color: DS.border } },
    axisTick: { lineStyle: { color: DS.border } },
    axisLabel: {
      color: DS.textDisabled,
      fontFamily: FONT_UI,
      fontSize: 10,
    },
    splitLine: {
      lineStyle: {
        type: "solid",
        width: 1,
        color: DS.border,
      },
    },
  },

  legend: {
    icon: "rect",
    itemWidth: 12,
    itemHeight: 12,
    itemStyle: {
      borderColor: DS.black,
      borderWidth: 1,
    },
    textStyle: {
      fontFamily: FONT_UI,
      fontSize: 11,
      color: DS.black,
    },
  },

  tooltip: {
    backgroundColor: DS.black,
    borderColor: DS.black,
    textStyle: {
      color: "#FFFFFF",
      fontFamily: FONT_UI,
      fontSize: 11,
    },
    extraCssText: "border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);",
  },
};

let registered = false;

export function registerWprTheme() {
  if (registered) return;
  echarts.registerTheme("wpr", wprTheme);
  registered = true;
}
